import { useEffect, useState } from 'react';

export const useTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('havenlytics-theme');
    return savedTheme === 'dark';
  });

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('havenlytics-theme', 'dark');
      // Force dark background immediately
      document.body.style.background = 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)';
      document.documentElement.style.background = '#1a1a2e';
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('havenlytics-theme', 'light');
      // Reset backgrounds
      document.body.style.background = '';
      document.documentElement.style.background = '';
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  return { isDarkMode, toggleTheme };
};